import { cn } from '@/lib/utils';

import CRLogo from '@/assets/CR.png';

interface LoginBackdropProps {
  watermark?: 'right' | 'center' | null;
  className?: string;
}

/**
 * Shared auth atmosphere: a static hairline grid, two soft primary glow
 * blobs, and an optional oversized raven watermark. Purely decorative
 * (aria-hidden) and non-interactive.
 */
export function LoginBackdrop({
  watermark = null,
  className
}: LoginBackdropProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 overflow-hidden',
        className
      )}
    >
      <style>{`
        @keyframes cr-login-glow {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.08); }
        }
        @media (prefers-reduced-motion: reduce) {
          .cr-login-anim { animation: none !important; }
        }
      `}</style>

      <div
        className="absolute inset-0 opacity-[0.14]"
        style={{
          backgroundImage:
            'linear-gradient(hsl(var(--foreground)/0.6) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--foreground)/0.6) 1px, transparent 1px)',
          backgroundSize: '44px 44px'
        }}
      />
      <div
        className="cr-login-anim absolute -top-40 -left-32 h-[520px] w-[520px] rounded-full bg-primary/20 blur-3xl"
        style={{ animation: 'cr-login-glow 9s ease-in-out infinite' }}
      />
      <div
        className="cr-login-anim absolute -bottom-44 -right-32 h-[560px] w-[560px] rounded-full bg-primary/15 blur-3xl"
        style={{ animation: 'cr-login-glow 11s ease-in-out infinite 1s' }}
      />

      {watermark ? (
        <img
          src={CRLogo}
          alt=""
          className={cn(
            'absolute h-[62vh] w-[62vh] object-contain opacity-[0.12] mix-blend-screen',
            watermark === 'right'
              ? '-right-[8vh] top-1/2 -translate-y-1/2'
              : 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
          )}
        />
      ) : null}
    </div>
  );
}
